export const useCheckSvgIcon = (value: string) => {
  if (!value) {
    return false;
  }
  return value.match(/\.(svg)$/) !== null;
};
